import {
  saveRequestsList,
  // eslint-disable-next-line import/named
  saveSelectedRecord,
  // saveUpdateRecord,
} from '../Infrastructure/Requests.store';
import {
  getRequestLogic,
  getRequestsLogic,
  updateRequestLogic,
  postRequestLogic,
  getMoratoriumLogic,
  updateMoratoriumLogic,
  getSigloPartnerConfigStatusLogic,
} from './Requests.logic';

export async function getRequests(params) {
  const requests = await getRequestsLogic(params);
  saveRequestsList(requests);
}
export async function getRequest(id) {
  const request = await getRequestLogic(id);
  saveSelectedRecord(request);
}

export async function updateRequest(selected, values, isSigloConfigComplete) {
  return updateRequestLogic(selected, values, isSigloConfigComplete);
}

export async function postRequest(values, isSigloConfigComplete) {
  return postRequestLogic(values, isSigloConfigComplete);
}

export async function getSigloPartnerConfigStatus(partnerId) {
  return getSigloPartnerConfigStatusLogic(partnerId);
}

export async function getMoratorium(id) {
  return getMoratoriumLogic(id);
}

export async function updateMoratorium(moratorium, values) {
  return updateMoratoriumLogic(moratorium, values);
}
